import React, { useEffect, useState } from 'react'
import { useFirebaseApp } from 'reactfire'
import RoutePath from '../atoms/RoutePath'
import ProductCard from '../molecules/ProductCard'
import SubMenu from '../molecules/SubMenu'

const SubCategory=(props)=>{
  const category=props.match.params.category
  const subCategory=props.match.params.subCategory
  
  const firebase=useFirebaseApp()
  const firestore=firebase.firestore()

  const [state, setstate] = useState({products:[]})

  useEffect(()=>{
    document.documentElement.scrollTop=0
    firestore.collection(`products`).where('subCategory','array-contains',subCategory).get().then(
      snap=>{
        let products=[]
        snap.forEach(doc=>{
          products.push({id:doc.id,data:doc.data()})
        })
        setstate({
          products
        })
      }
    )
  },[firestore,subCategory])
    return (
      <>
      <SubMenu category={category} />
      <main className='sub-category'>
        <RoutePath categoryUrl={category} category={` ${category[0].toUpperCase()+category.slice(1)}`} subCategoryUrl={subCategory} subCategory={`/ ${subCategory[0].toUpperCase()+subCategory.slice(1)}`}/>
        <div className='line-cont'>

        <div className="line"></div>
        </div>
        <div className="products">
        <div className="products-grid">
          {
            state.products &&
            state.products.map(p=>(
              <ProductCard key={p.data.name} product={`${category}/${subCategory}/${p.id}` } name={p.data.name} price={p.data.price} image={p.data.images[0]} />
            ))
          }
        </div>
      </div>
      </main>
      </>
    )
}

export default SubCategory
